import controller from './main.controller';
import './main.less';

export default {
  controller,
  template: require('./main.html')
};



// WEBPACK FOOTER //
// src/app/main/main.component.ts